var SupportGetawaysMarketRateStatusAndNotesPresentation;

SupportGetawaysMarketRateStatusAndNotesPresentation = {
  confirmed: {
    status: "Booked",
    notes: "Your reservation had been confirmed, but you can double-check by giving the merchant a call at the phone number in your order details."
  },
  used: {
    status: "Reservation has passed",
    notes: ""
  },
  cancelled: {
    status: "Cancelled",
    notes: "Your 5% Groupon Bucks credit has also been cancelled."
  }
};

module.exports = SupportGetawaysMarketRateStatusAndNotesPresentation;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvcHJlc2VudGVycy9nZXRhd2F5c19tYXJrZXRfcmF0ZV9tZXNzYWdlcy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC9wcmVzZW50ZXJzL2dldGF3YXlzX21hcmtldF9yYXRlX21lc3NhZ2VzLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLG1EQUFBLEdBQ0M7RUFBQSxTQUFBLEVBQ0M7SUFBQSxNQUFBLEVBQVEsUUFBUjtJQUNBLEtBQUEsRUFBUSx3SUFEUjtHQUREO0VBR0EsSUFBQSxFQUNDO0lBQUEsTUFBQSxFQUFRLHdCQUFSO0lBQ0EsS0FBQSxFQUFPLEVBRFA7R0FKRDtFQU1BLFNBQUEsRUFDQztJQUFBLE1BQUEsRUFBUSxXQUFSO0lBQ0EsS0FBQSxFQUFPLHVEQURQO0dBUEQ7OztBQVVELE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
